/**
 * Kayıt sesleri (Ayarlar > Genel > Davranış). Ses dosyası yok: kısa tonlar
 * Web Audio ile üretiliyor — paket büyümüyor, CSP'ye dokunulmuyor.
 */

export type RecordingCue = 'start' | 'stop' | 'saved' | 'error';

interface Tone {
  /** Hz */
  frequency: number;
  /** Saniye cinsinden gecikme. */
  at: number;
  duration: number;
}

const CUES: Record<RecordingCue, Tone[]> = {
  // Yükselen ikili: kayıt başladı.
  start: [
    { frequency: 660, at: 0, duration: 0.09 },
    { frequency: 880, at: 0.1, duration: 0.12 },
  ],
  // Alçalan ikili: kayıt durdu.
  stop: [
    { frequency: 880, at: 0, duration: 0.09 },
    { frequency: 620, at: 0.1, duration: 0.14 },
  ],
  // Tek kısa tık: kayıt kaydedildi.
  saved: [{ frequency: 988, at: 0, duration: 0.12 }],
  // Kalın ikili: bir şeyler ters gitti.
  error: [
    { frequency: 300, at: 0, duration: 0.14 },
    { frequency: 220, at: 0.16, duration: 0.2 },
  ],
};

let context: AudioContext | null = null;

export function playRecordingCue(cue: RecordingCue): void {
  try {
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume();

    const now = context.currentTime;
    for (const tone of CUES[cue]) {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = tone.frequency;

      // Ani başlangıç/bitiş "tık" sesi yapıyor; kısa bir zarf yumuşatıyor.
      const start = now + tone.at;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.08, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + tone.duration);

      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + tone.duration + 0.02);
    }
  } catch {
    // Ses çalınamadıysa kayıt akışı bundan etkilenmemeli.
  }
}
